import { useEffect, useRef, type ReactNode } from 'react';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

/** Side panel on the native <dialog> (focus trap, Escape, inert page). Opens from the reading-start edge. */
export function Drawer({ open, onClose, title, children }: DrawerProps) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dlg = ref.current;
    if (!dlg) return;
    if (open && !dlg.open) dlg.showModal();
    if (!open && dlg.open) dlg.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      aria-label={title}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
      className="m-0 me-auto h-dvh max-h-none w-[min(320px,88vw)] max-w-none bg-transparent p-0 text-ink backdrop:backdrop-blur-[2px]"
    >
      {open && <div className="flex h-full animate-drawer-in flex-col bg-paper shadow-floating">{children}</div>}
    </dialog>
  );
}
